import { Breakpoint, Color, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { ReactComponent as ArrowDown } from '../../../../images/arrowLongDown.svg';
import { ReactComponent as ArrowRight } from '../../../../images/arrowLongRight.svg';
import { Color as VWColor } from '../../../../theme/colors';

export const Container = styled.div`
  padding-bottom: 60px;

  @media ${Breakpoint.Tablet} {
    border-bottom: 1px solid ${VWColor.navyBlue};
    margin-bottom: 60px;
  }
`;

export const Table = styled.div`
  border: 1px solid ${Color.Gray300};
  display: flex;
  flex-direction: column;

  @media ${Breakpoint.Tablet} {
    display: block;
  }
`;

export const Headers = styled.div`
  display: flex;
  border-bottom: 1px solid ${Color.Gray300};
  background-color: ${Color.Gray100};
`;

export const Content = styled.div`
  display: flex;
  background-color: ${Color.White};
`;

export const Cell = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid ${Color.Gray300};
  padding: 14px 24px;
  background-color: ${Color.White};

  @media ${Breakpoint.Tablet} {
    width: 23%;
  }
`;

export const HeaderCell = styled(Cell)`
  justify-content: space-between;
  min-height: 64px;
  background-color: ${Color.Gray100};

  @media ${Breakpoint.Tablet} {
    &:first-child {
      border: none;
      width: 31%;
    }
  }
`;

export const FirstContentCell = styled(Cell)`
  padding: 19.5px 16px;
  border: none;
  width: 31%;
`;

export const DoubleCell = styled(Cell)`
  flex-direction: column;
  padding: 0;
`;

export const SubCell = styled.div`
  height: 50%;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 24px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.Gray300};
  }
`;

export const List = styled.ul`
  padding-left: 16px;
  list-style: disc;
`;

export const ListItem = styled.li``;

export const Label = styled.div`
  height: 28px;
  width: fit-content;
  border-radius: 24px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  background-color: ${Color.Gray100};
`;

export const GrayTypography = styled(Typography)`
  color: ${Color.Gray800};
`;

export const BlueTypography = styled(Typography)`
  color: ${(): string => VWColor.brandBasic};
`;

export const Title = styled(GrayTypography)`
  margin: 0 0 24px 20px;

  @media ${Breakpoint.Tablet} {
    margin: 0 0 30px 0;
  }
`;

export const Answer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TablesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ArrowRightIcon = styled(ArrowRight)`
  flex-shrink: 0;
  fill: ${(): string => VWColor.brandBasic};
`;

export const ArrowDownIcon = styled(ArrowDown)`
  flex-shrink: 0;
  fill: ${(): string => VWColor.brandBasic};
`;
